module.exports = __webpack_public_path__ + "img/login.2cfbc045.png";